var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6158 12.0003C24.6158 5.37285 19.2691 0.000270844 12.6736 0.000270844C6.07814 0.000270844 0.731445 5.37285 0.731445 12.0003C0.731445 17.9898 5.09853 22.9543 10.8077 23.8545V15.469H7.77547V12.0003H10.8077V9.35652C10.8077 6.34902 12.5906 4.68777 15.3184 4.68777C16.625 4.68777 17.9916 4.92215 17.9916 4.92215V7.87527H16.4858C15.0023 7.87527 14.5396 8.80028 14.5396 9.74926V12.0003H17.8517L17.3222 15.469H14.5396V23.8545C20.2487 22.9543 24.6158 17.9898 24.6158 12.0003Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/Facebook-Logo.e6ebfbec5376b43e9f98a32aef33048e.svg";
export { ForwardRef as ReactComponent };